import { OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type ProductCountFormattedChange =
  ProjectChangeMap[ProjectChangeType.ProductElementCountFormatted];

/**
 * Build a partial element change for ProductElementCountFormatted.
 *
 * @param element - Current element state
 * @param change - Formatted value payload
 * @returns Partial<OneOfElements> or undefined
 */
export const productElementCountFormattedToChange = (
  element: OneOfElements,
  change: ProductCountFormattedChange,
): Partial<OneOfElements> | undefined => {
  if (!projectGuards.is.productElement(element)) return undefined;
  if (!element.count) return undefined;
  if (element.count.formatted === change.formatted) return undefined;

  return {
    count: { ...element.count, formatted: change.formatted },
  };
};
